import KeycloakService from "../Services/KeycloakService";

const RenderAuth = ({ children }) => (!KeycloakService.isLoggedIn()) ? children : null;

export default RenderAuth